<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block" v-if="$route.meta.breadcrumbTitle">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
      <!-- Card stats -->
      <!-- <b-row>
        <b-col xl="3" md="6" >
          <stats-card title="Total traffic"
                      type="gradient-red"
                      sub-title="350,897"
                      icon="ni ni-active-40">

            <template slot="footer">
              <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
        <b-col md="6" xl="3">
          <stats-card title="Total traffic"
                      type="gradient-orange"
                      sub-title="2,356"
                      icon="ni ni-chart-pie-35">

            <template slot="footer">
              <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
        <b-col md="6" xl="3">
          <stats-card title="Sales"
                      type="gradient-green"
                      sub-title="924"
                      icon="ni ni-money-coins">

            <template slot="footer">
              <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>

        </b-col>
        <b-col md="6" xl="3">
          <stats-card title="Performance"
                      type="gradient-info"
                      sub-title="49,65%"
                      icon="ni ni-chart-bar-32">

            <template slot="footer">
              <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
      </b-row> -->
    </base-header>
    <b-container fluid class="mt--5">
      <div class="card mb-4">
        <!-- Card header -->
        <div class="card-header">
          <h3 class="mb-0">GPS device details</h3>
        </div>
        <!-- Card body -->
        <div class="card-body">
          <b-form @submit.prevent="onSaveForm">
          <b-row>
            <b-col lg="12">
              <div class="form-group">
                <label class="form-control-label" for="deviceId">Id (IMEI)</label>
                <input type="text" class="form-control" id="deviceId" placeholder="Id (IMEI)" v-model="model.deviceId">
              </div>
            </b-col>
            <b-col lg="12">
              <div class="form-group">
                <label class="form-control-label" for="name">Name</label>
                <input type="text" class="form-control" id="name" placeholder="Name" v-model="model.name">
              </div>
            </b-col>
            <b-col lg="12">
              <div class="form-group">
                <label class="form-control-label" for="motorbike">Motorbike</label>
                <select class="form-control" v-model="model.motorbike">
                  <option v-bind:value="null">- Empty -</option>
                  <option v-for="motorbike in motorbikes" v-bind:key="motorbike.id" v-bind:value="motorbike.id">{{motorbike._name}}</option>
                </select>
              </div>
            </b-col>
            <b-col lg="12">
              <div class="form-group">
                <label class="form-control-label" for="autoAssignMotorbike">Autoassign motorbike</label>
                <base-checkbox v-model="model.autoAssignMotorbike">
                  With this feature enabled, any location emited by the GPS will be assigned to the selected motorbike.
                </base-checkbox>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-right">
              <base-button type="primary" native-type="submit" class="my-4" :disabled="!hasChanges">Save</base-button>
            </b-col>
          </b-row>
          </b-form>
        </div>
      </div>
    </b-container>
  </div>
</template>
<script>
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import StatsCard from '@/components/Cards/StatsCard';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'starter-page',
    components: {
      StatsCard,
      RouteBreadCrumb
    },
    data() {
      return {
        model: {}
      };
    },
    async mounted() {
      await this.listMotorbikes()
    },
    methods: {
      ...mapActions({
        listMotorbikes: 'motorbikes/fetch',
        createDevice: 'gpsdevices/create'
      }),
      async onSaveForm() {
        await this.createDevice(this.model)
        this.$router.push({ name: 'gpsdevice', params: {id: this.device._id}})
      }
    },
    computed: {
      ...mapGetters({
        motorbikes: 'motorbikes/motorbikes',
        device: 'gpsdevices/item'
      }),
      hasChanges () {
        let changes = 0
        const keys = [
          'deviceId',
          'name',
          'motorbike',
          'autoAssignMotorbike'
        ]
        Object.keys(this.model).filter(k => keys.indexOf(k) > -1).forEach(key => {
          if (this.model[key]) {
            changes++
          }
        })
        return !!(changes)
      }
    }
  };
</script>
<style scoped>
  .starter-page {
    min-height: calc(100vh - 380px);
  }
  .dropdown {
    z-index: 1000;
  }
</style>
